/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import * as Modals from "../modals";
import { closelightbox, openlightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Link } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import moment from "moment";
import "moment/locale/es";

const Factor = (props) => {
  moment.locale("es");
	const [zPos, setZPos] = useState(45)
  const [form, setForm] = useState([]);
  const [errors, setErrors] = useState([0, 0, 0, 0]);
  const [errsResp, setErrsResp] = useState([0, 0, 0, 0]);
  const [sendValue, setSendValue] = useState("sms");
  const [disabled, setDisabled] = useState(true);
  const [codeSend, setCodeSend] = useState("");
  const [errorCode, setErrorCode] = useState("");

  const [options, setOptions] = useState({
		title: "",
		subTitle: "",
		type: "",
		button: "",
	});

  const sendOptions = [
    { label: "", value: "" },
    { label: "SMS", value: "sms" },
    { label: "Email", value: "email" },
  ];

  useEffect(() => {
    init();
  }, [props.contentModal]);

	
  const init = () => {
    if (props.contentModal.fields) {
      let f = form;
      for (let i = 0; i < props.contentModal.fields.length; i++) {
        let field = props.contentModal.fields[i];
        field["value"] = "";
        field["show"] = true;
        if (i + 1 == props.contentModal.fields.length) {
          field["show"] = false;
        }
        f.push(field);
      }
      setForm(JSON.parse(JSON.stringify(f)));
    }
    if (props.contentModal.type == "send") {
      setDisabled(false);
    }
		switch (props.contentModal.type) {
			case "1FA":
				setOptions(data => ({...data, title: "Verificar identidad para cambio de datos", subTitle: "Por favor, solicita al cliente los siguientes datos para su confirmación del cambio:", button: "Confirmar", type: props.contentModal.type }))
				break;
			case "2FA":
				setOptions(data => ({...data, title: "Verificar identidad para cambio de datos", subTitle: "Por favor, solicita al cliente los siguientes datos para su confirmación del cambio:", button: "Enviar código", type: props.contentModal.type }))
				break;
			case "verify":
				setOptions(data => ({...data, title: "Verificar identidad para cambio de datos", subTitle: "Se ha enviado un código para verificar su identidad. Solicitar al cliente el código recibido e ingresarlo:", button: "Verificar", type: props.contentModal.type }))
				break;
			case "send":
				setOptions(data => ({...data, title: "Enviar código", subTitle: "Selecciona el metodo de envío:", button: "Enviar código", type: props.contentModal.type }))
				break;
		
			default:
				break;
		}
  };

  const send = async () => {
    props.changeLoader(true);
		setZPos(-1)
    props.changeAlert(false, "", "");
    if (props.contentModal.type != "send") {
      let f = form;
      for (let i = 0; i < f.length; i++) {
        if (f[i]["type"] == "date") {
          f[i]["value"] = f[i]["value"].substring(0, 10);
        }
      }
      let data = {
        type: props.contentModal.type,
        fields: f,
        send: sendValue,
        customerUuid: props.contentModal.customer_uuid,
        //uuid_factor: props.contentModal.uuid_factor
      };

      let request = await API.service( props.intent, data, props.pos, props.changeAlert, props.changeLoader, props.history );
      if ( request.status == 200 && request.data.data.response == "BAD" && request.data.data.content ) {
        let f = form;
        f[3]["show"] = true;
        setErrsResp(JSON.parse(JSON.stringify(request.data.data.content.fields)));
        setForm(JSON.parse(JSON.stringify(f)));

        props.changeLoader(false);
		    setZPos(45);
      }

      if ( request.status == 200 && request.data.data.response == "BAD" && !request.data.data.content ) {
        closelightbox();
        props.changeLoader(false);
		    setZPos(45);
      }

      if ( request.status == 200 && request.data.data.response == "OK" && request.data.data.content ) {
        props.changeLoader(false);
		    setZPos(45);
        
        closelightbox();
        const as = (
          <Modals.Factor
            intent={props.intent}
            contentModal={request.data.data.content}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            history={props.history}
            key="factor"
          />
        );
        openlightbox(as);
      }

      if ( request.status == 200 && request.data.data.response == "OK" && !request.data.data.content ) {
        if(props["continue"]){
          await props.continue();
        } else {
          props.changeAlert(true, 'success', 'Factor autorizado, puede continuar.');
        }
        closelightbox();
        props.changeLoader(false);
      }
    } else {
      await resend(sendValue);
      props.changeLoader(false);
      setZPos(45);
    }
  };

  const changeCode = (e) => {
    if ( e.target.value > -1 && e.target.value < 10000 && e.target.value.length <= 4 ) {
      setCodeSend(e.target.value);
    }

    if (e.target.value.length != 4) {
      setDisabled(true);     
      setErrorCode("El código debe tener 4 digitos");
    } else {
      setDisabled(false);   
      setErrorCode("");
    }
  };

  const resend = async (type) => {
    props.changeLoader(true);
		setZPos(-1)
    props.changeAlert(false, "", "");
    let data = {
      resend: type,
      customerUuid: props.contentModal.customer_uuid,
    };

    let request = await API.service( props.intent, data, props.pos, props.changeAlert, props.changeLoader, props.history );
    if (request.status == 200 && request.data.data.response == "OK") {
      props.changeAlert(true, "OK", request.data.data.message);
      if (props.contentModal.type == "send") {
        let contentModal = {
          customer_uuid: props.contentModal.customer_uuid,
          type: "verify",
          uuid_factor: props.contentModal.uuid_factor,
        };
        closelightbox();
        const as = (
          <Modals.Factor
            intent={props.intent}
            contentModal={contentModal}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            history={props.history}
            key="factor"
          />
        );
        openlightbox(as);
      }
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const validate = async () => {
    props.changeLoader(true);
		setZPos(-1)
    props.changeAlert(false, "", "");
    let data = {
      code: codeSend,
      customerUuid: props.contentModal.customer_uuid,
    };

    let request = await API.service( props.intent, data, props.pos, props.changeAlert, props.changeLoader, props.history );
    if (request.status == 200 && request.data.data.response == "BAD" && !request.data.data.content ) {
      closelightbox();
    }
    if (request.status == 200 && request.data.data.response == "BAD" && request.data.data.content ) {
      setErrorCode(request.data.data.message);
    }
    if (request.status == 200 && request.data.data.response == "OK") {
      closelightbox();
      props.changeAlert(true, "OK", request.data.data.message);
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const changeValue = (index, e) => {
    let f = form;
    let errs = errors;

    if (e.target) {
      f[index]["value"] = e.target.value;
      if (e.target.value.length > 0) {
        errs[index] = 0;
      } else {
        errs[index] = 1;
      }
    } else {
      f[index]["value"] = e;
    }
    verifyButton(errs, sendValue, f);
    setErrors(JSON.parse(JSON.stringify(errs)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const changeSend = (e) => {
    let f = form;
    let errs = errors;
    verifyButton(errs, e.target.value, f);
    setSendValue(e.target.value);
  };

  const verifyButton = (errs, value, fields) => {
    if (props.contentModal.type != "send") {
      let totalErr = 0;
      for (let i = 0; i < errs.length; i++) {
        if (errs[i]) {
          totalErr++;
        }
      }
      for (let i = 0; i < fields.length; i++) {
        if (fields[i]["value"].length == 0) {
          totalErr++;
        }
      }
      if (!value) {
        totalErr++;
      }
      if (totalErr <= 1) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      if (!value) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    //setDisabled(val);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					{options.title}
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>
				
				<DialogContent style={{overflowY: "hidden"}}>
					<Grid container spacing={2} >
						<Grid item xs={12} sx={{ marginBottom: "18px" }}>
						  {options.subTitle}
						</Grid>

						{(props.contentModal.type == "2FA" || props.contentModal.type == "1FA") &&
							form?.map((data, index) => {
								if(data.show){
									if(data.type === "select"){
										return <Grid item xs={6} key={index}>
											<TextField
												label={data["label"]} value={data["value"]} onChange={changeValue.bind(this, index)} select error={errsResp[index] == 1 || (errors[index] == 1 && errsResp[index] == 0)} helperText={errors[index] == 1 && errsResp[index] == 0 ? "Dato obligatorio" : errors[index] == 1 ? 'Dato inválido' : ''} size="small" fullWidth >
													<MenuItem value={""}>Seleccionar opción</MenuItem>
													{data["values"].map((item, index) => {
														return <MenuItem key={`option-${index}`} value={item.value}>{item.label}</MenuItem>
													})}
											</TextField>
										</Grid>
									} else {
										return <Grid item xs={6} key={index}>
											<TextField
												label={data["label"]} value={data["type"] === "date" ? (data["value"] || new Date().toJSON().substring(0, 10)) : data["value"]} onChange={changeValue.bind(this, index)} type={data.type} error={errsResp[index] == 1 || (errors[index] == 1 && errsResp[index] == 0)} helperText={errors[index] == 1 && errsResp[index] == 0 ? "Dato obligatorio" : errors[index] == 1 ? 'Dato inválido' : ''} size="small" fullWidth />
										</Grid>
									}
								}
							})
						}

						{(options.type == "2FA" || options.type == "send") &&
							<Grid item xs={6}>
								<TextField
									label={"Confirmar cambio por:"} value={sendValue}  onChange={changeSend.bind(this)} select error={!sendValue} helperText={!sendValue ? "Dato obligatorio" : ''} size="small" fullWidth >
										{sendOptions?.map((item, index) => {
											return <MenuItem key={`option-${index}`} value={item.value}>{item.label}</MenuItem>
										})}
								</TextField>
							</Grid>						
						}

						{options.type == "verify" &&
							<Grid item xs={6}>
								<TextField
								  label={"Código"} value={codeSend} onChange={changeCode.bind(this)} type={"number"} placeholder={"0000"} error={errorCode !== ""} helperText={errorCode ? errorCode : ''} size="small" fullWidth />
							</Grid>						
						}
						{options.type == "verify" &&
							<Grid item xs={12} >
								<hr style={{margin: "6px 0 14px 0"}}/>
								<Link	onClick={resend.bind(this, "sms")} component="button" variant="body2" style={{paddingRight: "14px", color: "#3743AA", fontSize: "1rem", textDecorationColor: "#3743AA"}}>Reenviar código SMS</Link>					
								<Link	onClick={resend.bind(this, "email")} component="button" variant="body2" style={{color: "#3743AA", fontSize: "1rem", textDecorationColor: "#3743AA"}}>Enviar código por correo</Link>		
							</Grid>
						}
					</Grid>
				</DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button disabled={disabled} variant="contained" onClick={options.type === "verify" ? validate.bind(this) : send.bind(this)} >{options.button}</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default Factor;
